// src/components/PageTransition.tsx
import * as React from "react";
import { AnimatePresence, motion } from "framer-motion";

const variants = {
  initial: { opacity: 1, y: 4 },
  in: { opacity: 1, y: 0 },
  out: { opacity: 1, y: -4 },
};

export default function PageTransition({ element, location }) {
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        variants={variants}
        initial="initial"
        animate="in"
        exit="out"
        transition={{ duration: 0.25, ease: "easeOut" }}
      >
        {element}
      </motion.div>
    </AnimatePresence>
  );
}
